import { Injectable } from '@angular/core';
import {
  PlanDetails,
  Product
} from '../interfaces/product.interface';
import {
  PlanAttributes,
  SummaryView,
  IconographyBenefit,
  PlanDocumentBenefit
} from '../interfaces/plan-attributes.interface';
import { BENEFITS_TYPES, PlanDetailsRenderableCategory, PlanDetailsRenderableGroup } from './types/plan-details.types';
import { MedicalBenefit } from '../interfaces/plan-attributes.interface';
 

@Injectable({
  providedIn: 'root'
})
export class PlanDetailsTransformationUtility {

  constructor() { }

  /**
   * This method loops through plans / benefits and constructions a normalized/typed structure for presentation on UI
   * Benefits are mapped to the plan's they are associated with - so one can generate a matrix table structure for comparing plans
   */
  transformPlans(plans: PlanDetails[]): PlanDetailsRenderableCategory[] {
    /** Copy this for each benefit group */
    const template: PlanDetailsRenderableGroup = {
      name: null, // 'Medical Services',
      plans: [], // ['plan 1', 'plan 2'],
      benefits: [], // [{name:'benefit name', id: '1'}],
      planBenefits: {},
      benefitsType: null,
      hideLabel: null
    };

    const categoryTemplate: PlanDetailsRenderableCategory = {
      benefitGroupData: [],
      categoryName: null,
      hideLabel: null
    }

    let renderableCats: PlanDetailsRenderableCategory[] = [];

    let renderableGroups: PlanDetailsRenderableGroup[] = [];

    /** Align name with ENUM for comparison */
    function normalizeCategoryName(categoryName: string): string {
      return categoryName.replace(/ /g, '_').toUpperCase();
    }

    /** Loop through Plans */
    plans.forEach((plan: PlanDetails) => {

      /** PlanDetails is extended by interfaces which are already Products, this is safe */
      const planMeta = (plan as unknown as Product<PlanAttributes, SummaryView>);
      const planId = planMeta.attributes.PLAN_ID;

      (plan.detailView.benefitGrid).forEach(benefitGridItem => {

        const existingMasterCategory = renderableCats.filter(masterCatItem => masterCatItem.categoryName === benefitGridItem.masterCategory.masterCategoryName);
        
        let edittingMasterCat: PlanDetailsRenderableCategory;
        if (existingMasterCategory.length === 0){
          const newMasterCat = JSON.parse(JSON.stringify(categoryTemplate));
          newMasterCat.categoryName = benefitGridItem.masterCategory.masterCategoryName;
          newMasterCat.hideLabel = benefitGridItem.masterCategory.hideLabel;
          edittingMasterCat = newMasterCat;
          renderableCats.push(edittingMasterCat);
        } else {
          edittingMasterCat = existingMasterCategory[0];
        }



        (benefitGridItem.masterCategory.categories).forEach(group => {
          const existingGroup = renderableGroups.filter(catItem => catItem.name === group.category);

          let edittingGroup: PlanDetailsRenderableGroup;
          if (existingGroup.length === 0) {
            const newGroup = JSON.parse(JSON.stringify(template));
            newGroup.name = group.category;
            newGroup.hideLabel = group.hideLabel;
            edittingGroup = newGroup;
          } else {
            edittingGroup = existingGroup[0];
          }

          const hasGroupAlreadyBeenIdentifiedForThisCat = edittingMasterCat.benefitGroupData.filter(mappedGroup => group.category === mappedGroup.name).length > 0;
          if (!hasGroupAlreadyBeenIdentifiedForThisCat) {
            edittingMasterCat.benefitGroupData.push(edittingGroup)
          }

          const hasPlanAlreadyBeenIdentifiedForThisGroup = edittingGroup.plans.filter(mappedPlan => planId === mappedPlan.id).length > 0;

          if (!hasPlanAlreadyBeenIdentifiedForThisGroup) {
            edittingGroup.plans.push({
              name: planMeta.productName,
              id: planMeta.attributes.PLAN_ID
            })
          }

          if (!edittingGroup.planBenefits[planId]) {
            edittingGroup.planBenefits[planId] = {};
          }

          group.attributes.forEach(attr => {
            let groupName = attr.attributeContent["name"];

            const hasBenefitBeenMapped = edittingGroup.benefits.filter(benefitMetaItem => benefitMetaItem.id === groupName).length > 0;

            if (!hasBenefitBeenMapped) {
              edittingGroup.benefits.push({
                name: groupName,
                id: groupName,
                atLeastOneINN: null,
                atLeastOneOON: null
              })
            }

            switch (normalizeCategoryName(group.category)) {
              case BENEFITS_TYPES.ICONOGRAPHY:
                /** This might be unused */
                const indicatorItemAttr = attr.attributeContent as IconographyBenefit;
                edittingGroup.planBenefits[planId][attr.attributeContent.name] = indicatorItemAttr['Value'];
                edittingGroup.benefitsType = BENEFITS_TYPES.ICONOGRAPHY;

                break;
              case BENEFITS_TYPES.PLAN_DOCUMENTS:
                const planDocAttr = attr.attributeContent as PlanDocumentBenefit;
                edittingGroup.planBenefits[planId][attr.attributeContent.name] = planDocAttr['Value'];
                edittingGroup.benefitsType = BENEFITS_TYPES.PLAN_DOCUMENTS;

                break;
              default:
                edittingGroup.planBenefits[planId][attr.attributeContent.name] = {};
                const attrCont: MedicalBenefit = attr.attributeContent as MedicalBenefit;
                for (const tier in attrCont) {
                  if (tier !== "name") {
                    edittingGroup.planBenefits[planId][attr.attributeContent.name][tier] = attr.attributeContent[tier];
                  }
                }

                edittingGroup.benefitsType = BENEFITS_TYPES.MEDICAL_BENEFIT;

              break;
            }
          });

          if (existingGroup.length === 0) {
            renderableGroups.push(edittingGroup);
          }

        });
        
      });
    });

    return renderableCats;
  }
  
} 
